<template>
  <div class="goods_logistics_setup">
    <!--tabs切换-->
    <div class="baby_manage_tabs_box">
      <ul>
        <li class="active">货品物流设置</li>
        <li @click="tabsChange('generalLogistics')">通用物流设置</li>
      </ul>
    </div>

    <!--货品物流设置模糊查询头部-->
    <div class="goods_logistics_setup_top">
      <div class="ml5 mr10">
        <el-select v-model="selectChannel" multiple collapse-tags placeholder="渠道">
          <el-option
            v-for="item in channelList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="mr10">
        <el-select v-model="selectStore" multiple collapse-tags placeholder="店铺">
          <el-option
            v-for="item in storeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="mr10">
        <el-select v-model="selectCourierCompany" multiple collapse-tags placeholder="快递公司">
          <el-option
            v-for="item in courierCompanyList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div><input type="text" placeholder="货号" maxlength="20" v-model.trim="goodsNum"></div>
      <button class="btn_normal ml20" @click="query()">查询</button>
      <button class="btn_normal ml10" @click="ctrlBtn('add', null)">增加</button>
      <button class="btn_normal ml10" @click="ctrlBtn('batchDel', null)">批量删除</button>
      <button class="btn_normal ml10" @click="getStoreroomGoodsLogisticImportExcelTemplet()">下载模板</button>
      <button class="btn_normal ml10" @click="ctrlBtn('import', null)">导入货品物流</button>
    </div>
    <!--货品物流设置模糊查询列表-->
    <div class="goods_logistics_setup_content">
      <table class="table tb_border">
        <thead>
        <tr>
          <th style="width: 30px;"><input type="checkbox" title="全选" v-model="checkAll" @click="checkOneOrAll()"/></th>
          <th>货号</th>
          <!--<th>品名</th>-->
          <th>店铺</th>
          <th>渠道</th>
          <th>物流</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <td style="width: 30px;"><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>
          <td>{{item.GoodsId}}</td>
          <!--<td>假的品名</td>-->
          <td>{{item.ShopName}}</td>
          <td>{{item.StoreroomName}}</td>
          <td>{{item.LogisticName}}</td>
          <td><a class="fcLinkA" @click="ctrlBtn('del', item)">删除</a></td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="6">暂时没有相关信息</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div class="paging" v-if="list.length">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <goods-logistics-setup-embed-msg v-if="isShow"
                                     :title="dialogTitle"
                                     :showType="dialogShowType"
                                     :msg="dialogMsg" @cancelbtn="getSelectDialogEmbed"></goods-logistics-setup-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script>
  import GoodsLogisticsSetupEmbedMsg from './goods-logistics-setup-embed-msg';
  import MsgDialog from '../../../public-component/msg-dialog';
  import LoadingDialog from '../../../public-component/loading-dialog';

  export default {
    name: 'goods-logistics-setup',
    components: {GoodsLogisticsSetupEmbedMsg, MsgDialog, LoadingDialog},
    watch: { // 深度watch
      'checkboxModel': function (val) {
        let flag = true;
        val.forEach((value) => {
          if (!value) {
            flag = false;
            return flag;
          }
        });
        this.checkAll = flag;
      } // 单选
    },
    data() {
      return {
        list: [], // 列表信息
        checkAll: false, // 全选
        checkboxModel: [], // checkbox框值
        channelList: [], // 渠道下拉
        // selectChannel: '', // 渠道选择
        selectChannel: [], // 渠道选择 2022-07-18 改为传多选项
        storeList: [], // 店铺下拉
        // selectStore: '', // 店铺选择
        selectStore: [], // 店铺选择 2022-07-18 改为传多选项
        courierCompanyList: [], // 快递公司下拉
        // selectCourierCompany: '', // 选择的快递公司
        selectCourierCompany: [], // 选择的快递公司 2022-07-18 改为传多选项
        goodsNum: null, // 货号
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        dialogMsg: null, // 弹出框信息
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // 获取店铺下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg) {
            if (res.data.resData.length) {
              this.storeList = res.data.resData;
              // this.selectStore = res.data.resData[0].id;
              this.storeList.splice(this.storeList.findIndex(item => item.id === 0), 1);
            } else {
              this.storeList = res.data.resData;
              // this.selectStore = '';
              this.selectStore = [];
            }
            // this.storeList.splice(0, 0, {id: '', text: '所有店铺'});
          } else {
            this.storeList = [];
            // this.selectStore = res.data.errorMsg;
            this.selectStore = [];
          }
        });
      },

      // tabs切换
      tabsChange(value) {
        this.$emit('tabschange', {type: value});
      },

      // 查询
      query() {
        this.currentPage = 1;
        this.getStoreroomGoodsLogisticPageData();
      },

      // 加载渠道配货号物流分页数据
      getStoreroomGoodsLogisticPageData() {
        this.isLoading = true;
        const params = {
          storeroomId: this.selectChannel,
          logisticId: this.selectCourierCompany,
          goodsId: this.goodsNum,
          shopId: this.selectStore,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        console.log(params);
        this.$axios.post(this.Global.getStoreroomGoodsLogisticPageData, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (!res.data.errorMsg.length) {
              self.checkboxModel = [];
              self.list = res.data.resData.DataList;
              self.total = res.data.resData.TotalCounts;
              for (let i = 0; i < self.list.length; i++) {
                self.checkboxModel.push(false);
              }
            } else {
              self.isMsg = true;
              self.isSuc = false;
              self.txtMsg = res.data.errorMsg;
            }
          }, 500);
        });
      },

      // 获取渠道下拉框信息
      getAllStoreroomsList() {
        this.$axios.get(this.Global.getAllStoreroomsList).then((res) => {
          console.log(res.data.errorMsg);
          if (!res.data.errorMsg) {
            this.channelList = res.data.resData;
            // this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            this.selectChannel = [];
          } else {
            this.channelList = [];
            // this.selectChannel = res.data.errorMsg;
            this.selectChannel = res.data.errorMsg;
          }
        });
      },

      // 获取快递公司下拉框
      getAllLogisticList() {
        this.$axios.get(this.Global.getAllLogisticList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.courierCompanyList = res.data.resData;
            // this.courierCompanyList.splice(0, 0, {id: '', text: '所有快递'});
            // this.selectCourierCompany = '';
            this.selectCourierCompany = [];
          } else {
            this.courierCompanyList = [];
            // this.selectCourierCompany = res.data.errorMsg;
            this.selectCourierCompany = [];
          }
        });
      },

      // 店铺货号指定快递导入模板
      getStoreroomGoodsLogisticImportExcelTemplet() {
        this.$axios.get(this.Global.getStoreroomGoodsLogisticImportExcelTemplet).then((res) => {
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 操作按钮
      ctrlBtn(type, msg) {
        this.dialogShowType = type;
        let arr = [];
        switch (type) {
          case 'add':
            this.isShow = true;
            this.dialogMsg = msg;
            this.dialogTitle = '添加';
            break;
          case 'del':
            this.isShow = true;
            arr.push(msg.Id);
            this.dialogMsg = arr;
            this.dialogTitle = '提示';
            break;
          case 'import':
            this.isShow = true;
            arr.push(msg.Id);
            this.dialogMsg = msg;
            this.dialogTitle = '提示';
            break;
          case 'batchDel':
            for (let i in this.checkboxModel) {
              if (this.checkboxModel[i]) {
                arr.push(this.list[i].Id);
              }
            }
            if (!arr.length) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请选择要批量删除的数据';
              return;
            }
            this.isShow = true;
            this.dialogMsg = arr;
            this.dialogTitle = '提示';
            break;
        }
      },

      // 单选/全选
      checkOneOrAll() {
        for (let i = 0; i < this.checkboxModel.length; i++) {
          this.checkboxModel[i] = !this.checkAll;
        }
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        if (val < this.checkboxModel.length) {
          this.checkboxModel = this.checkboxModel.splice(0, val);
        }
        this.getStoreroomGoodsLogisticPageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getStoreroomGoodsLogisticPageData();
        this.checkboxModel = [];
        this.list.forEach(() => {
          this.checkboxModel.push(false);
        });
        /* for (let i in this.list) {
           console.log(i);
           this.checkboxModel.push(false);
         } */
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          if (this.dialogShowType === 'del' || this.dialogShowType === 'batchDel') {
            this.currentPage = 1;
          }
          this.getStoreroomGoodsLogisticPageData();
          this.checkboxModel = [];
          this.list.forEach(() => {
            this.checkboxModel.push(false);
          });
         /* for (let i in this.list) {
            console.log(i);
            this.checkboxModel.push(false);
          } */
          // this.isMsg = true;
          // this.isSuc = true;
          // this.txtMsg = '操作成功';
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.getStoreroomGoodsLogisticPageData();
      this.getAllPXShopList();
      this.getAllStoreroomsList();
      this.getAllLogisticList();
    }
  }
</script>-

<style lang="scss" scoped>
  @import "../../../../assets/css/home-view";

  .goods_logistics_setup_top {
    margin: 10px 0;

    & > div {
      display: inline-block;
    }
  }

  .goods_logistics_setup_content {
    padding: 0 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/default-delivery-logistics/goods-logistics-setup.vue